export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20flat%20lay%20composition%20featuring%20carefully%20arranged%20fashion%20pieces%20including%20a%20draped%20camel%20coat%20folded%20cream%20sweater%20and%20neutral%20toned%20accessories%20on%20a%20light%20warm%20sand%20colored%20linen%20surface%2C%20soft%20natural%20window%20light%20casting%20gentle%20diagonal%20shadows%20across%20the%20scene%2C%20minimalist%20luxury%20fashion%20catalog%20aesthetic%20with%20sophisticated%20styling%20and%20generous%20negative%20space%2C%20warm%20inviting%20atmosphere%20with%20refined%20editorial%20sensibility&width=1800&height=1200&seq=hero-bg-v3-fashion&orientation=landscape"
          alt="ACBuySpreadsheet fashion products flat lay"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-12 lg:gap-8">
          <div className="flex-1 pt-12 md:pt-16">
            <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-black text-white leading-none tracking-tight">
              <span className="block">SMART</span>
              <span className="block text-primary-400">ACBUY</span>
              <span className="block">SPREADSHEET</span>
            </h1>
            <p className="mt-6 text-white/80 text-base md:text-lg max-w-lg leading-relaxed">
              The smartest spreadsheet tracking system for modern workflows. Simplify tracking, improve productivity, and replace outdated manual tools.
            </p>
          </div>

          <div className="flex flex-col gap-4 md:gap-5 w-full lg:w-auto lg:min-w-[320px]">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center gap-3 px-6 py-4 bg-white/10 backdrop-blur-sm border border-white/25 rounded-xl text-white hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500">
                <i className="ri-arrow-right-up-line text-white text-lg"></i>
              </span>
              <span className="text-lg font-semibold">acbuy spreadsheet</span>
            </a>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center gap-3 px-6 py-5 bg-white rounded-xl text-foreground-950 hover:bg-white/95 transition-all cursor-pointer whitespace-nowrap shadow-lg"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950">
                <i className="ri-shopping-bag-line text-white text-lg"></i>
              </span>
              <span className="text-lg font-bold">Buy It Now</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}